import Raven from 'raven-js';

import config from '../config';

export class SentryHelper {
  static initialize(releaseData) {
    if (!config.enableSentry) {
      return;
    }

    const sentryConfigData = releaseData ? {
        release: releaseData.releaseNumber,
        environment: releaseData.environment,
        tags: {restaurantCode: releaseData.restaurantCode}
      } : {
        release: 'n/a',
        environment: 'local',
        tags: {restaurantCode: config.restaurantCode}
      };

    Raven.config(config.sentryUrl, sentryConfigData).install();
  }

  static logException(error, extra, tags) {
    if (!config.enableSentry) {
      return;
    }

    Raven.captureException(error, {
      extra,
      tags
    });
  }
}



// WEBPACK FOOTER //
// ./helpers/sentry.helper.js